import { Reducer } from 'redux';
import { ProjectUserManagementAction, ProjectUserManagementActionTypes } from './ProjectUserManagementActions';

export interface ProjectUserManagementState {
    selectedProjectUserGroupId: string;
    selectedProjectUserGroupName: string;
}

export const defaultProjectUserManagementState: ProjectUserManagementState = {
    selectedProjectUserGroupId: '',
    selectedProjectUserGroupName: ''
};

export const projectUserManagementReducer: Reducer<
    ProjectUserManagementState,
    ProjectUserManagementAction
> = (state = defaultProjectUserManagementState, action: ProjectUserManagementAction) => {
    switch (action.type) {
        case ProjectUserManagementActionTypes.PROJECT_USER_GROUP_SELECTION: {
            return {
                ...state,
                selectedProjectUserGroupId: action.payload.projectUserGroupId,
                selectedProjectUserGroupName: action.payload.projectUserGroupName
            };
        }
        default: {
            return state;
        }
    }
};
